export default "__VITE_ASSET__4b77e2db__"